import type { BreadcrumbItem } from '~/types/breadcrumbs'

export const formatBreadcrumbs = (
  breadcrumbs: BreadcrumbItem[],
  localePath: string = 'en-eu',
  isValidGender: (value: string) => boolean,
) => {
  return breadcrumbs.map((breadcrumb) => {
    const isGenderLink = isValidGender(breadcrumb.value)
    return {
      ...breadcrumb,
      to: isGenderLink
        ? `/${localePath}/${breadcrumb.value?.toLowerCase()}`
        : (breadcrumb.to?.['@id'] as string),
    }
  })
}
